import React, { useState, useEffect, memo, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';

import { PlanActions } from '../../../store/actions/plans';
import lupa from '../../../assets/images/busca.svg';

import HistoryDescription from './HistoryDescription';

import './HistoryPlan.css';

function HistoryPlan() {
  const [search, setSearch] = useState('');

  const company = useSelector((state) => state.companies.company);
  const historyCompanyPlan = useSelector(
    (state) => state.plans.historyCompanyPlan
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (company?._id) {
      dispatch(PlanActions.getHistoryCompanyPlan({ companyId: company._id }));
    }
  }, [company]);

  const changeFilter = (e) => {
    setSearch(e.target.value);
  };

  const filteredHistoricPlan = useMemo(() => {
    if (!search) return historyCompanyPlan;

    const findHistoricPlan = historyCompanyPlan.filter(
      (plan) =>
        plan.lastPlan?.name.toLowerCase().includes(search.toLowerCase()) ||
        plan.newPlan?.name.toLowerCase().includes(search.toLowerCase()) ||
        moment(plan.when)
          .format('DD/MM/YYYY')
          .toLowerCase()
          .includes(search.toLowerCase()) ||
        moment(plan.when)
          .format('HH:mm')
          .toLowerCase()
          .includes(search.toLowerCase()) ||
        plan.responsible.toLowerCase().includes(search.toLowerCase())
    );

    return findHistoricPlan;
  }, [historyCompanyPlan, search]);

  return (
    <div className="plan-container-history">
      <div className="plan-container-title">
        Histórico de alterações
        <div className="container-img-inpt-history-plan">
          <img src={lupa} alt="lupa" />
          <input placeholder="Buscar Plano" onChange={changeFilter} />
        </div>
        <div />
      </div>
      <div className="column-history-company title-table-history">
        <div className="dv-antigo-plano">Plano anterior</div>
        <div className="dv-novo-plano">Novo Plano</div>
        <div className="dv-descricao">Descrição</div>
        <div className="dv-data">Data</div>
        <div className="dv-hora">Hora</div>
        <div className="dv-responsavel">Responsável</div>
      </div>
      {filteredHistoricPlan?.map((history) => (
        <div key={history?._id}>
          <div className="border-line" />
          <div className="column-history-company column-info-history">
            <div className="dv-antigo-plano">
              {history.lastPlan?.name ? history.lastPlan.name : '-'}
            </div>
            <div className="dv-novo-plano">
              {history.newPlan?.name ? history.newPlan?.name : '-'}
            </div>
            <div className="container-history-channels dv-descricao">
              <HistoryDescription history={history} />
            </div>
            <div className="dv-data">
              {moment(history.when).format('DD/MM/YYYY')}
            </div>
            <div className="dv-hora">
              {moment(history.when).format('HH:mm')}
            </div>
            <div className="dv-responsavel">{history.responsible}</div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default withRouter(memo(HistoryPlan));
